import { HeadCellSortState } from '@foradevelopment/fora-ui';

import { PayReportsTableSortId } from '../../../common/types';

export type PayReportsTableSortState = typeof defaultPayReportsListSortState;
export type PayReportsTableSortIdKeys = keyof typeof defaultPayReportsListSortState;

export const defaultPayReportsListSortState = {
  [PayReportsTableSortId.ReportingPeriods]: HeadCellSortState.None,
  [PayReportsTableSortId.Status]: HeadCellSortState.None,
};
